module.exports = __webpack_public_path__ + "static/media/elrich.94410d0b.jpg";